module.exports = __webpack_public_path__ + "static/media/Week 3 Tuesday.055d3a2e.png";